/* eslint-disable @next/next/no-sync-scripts */
/* eslint-disable react/no-danger */
import { bankOfferCSS } from "../../utils/stylesUtil/bankOffer";
import { baseMinCss } from "../../utils/stylesUtil/baseMin";
import { commonHeaderCss } from "../../utils/stylesUtil/commonHeader";
import { flightsInlineCSSMob } from "../../utils/stylesUtil/flightsInlinecssMob";
import { footerMobCss } from "../../utils/stylesUtil/footerMobCss";
import { jqueryUIMinCss } from "../../utils/stylesUtil/jqueryUIMin";
import { seoBaseMin } from "../../utils/stylesUtil/seoBase";
import { seoFlightMobCss } from "../../utils/stylesUtil/seoFlightMob";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";

export const appendHeadCityPWA = (props) => {
  const { lang, appConfig, tokens, pageLoad = {}, currentDomainName, devId, mcid } = props || {};

  let cssPath;
  let jsPath;
  //   let gliderPath;
  //   let seoListingPath;
  //   let staticWidgetPath;
  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    jsPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js`;
    // gliderPath = `${appConfig.jsPath}/seo/assets/seocss/js/glider.js?v=${appConfig.resourceVersion}`;
    // seoListingPath = `${cssPath}/flight_unification/seoListing.min.css?v=${appConfig.resourceVersion}`;
    // staticWidgetPath = lang === 'hin' ? `https://jsak.mmtcdn.com/seo/hotels-new/seo/assets/js/flights/hiStaticSeoWidget.min.js?v=${appConfig.resourceVersion}` : `https://jsak.mmtcdn.com/seo/hotels-new/seo/assets/js/flights/staticSeoWidget.min.js?v=${appConfig.resourceVersion}`;
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    jsPath = "http://localhost:3000/_next/static/js";
    // gliderPath = '/js/core/glider.js';
    // seoListingPath = '/css/seoListing.css';
    // staticWidgetPath = lang === 'hin' ? '/js/core/hiStaticSeoWidget.js' : '/js/core/staticSeoWidget.js';
  }
  return (
    <>
      <link rel="icon" type="image/x-icon" href="https://www.makemytrip.com/favicon.ico" />
      <link href="https://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://bid.g.doubleclick.net" rel="preconnect" crossOrigin />
      <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossOrigin />
      <script
        dangerouslySetInnerHTML={{
          __html: `var currentDateddMMyy = '${tokens?.cheap_ddMMyy || ""}';
          window.currentDomain = "${currentDomainName || ""}";
  window.pageLoad = ${JSON.stringify(pageLoad)};
	window.isSeoMain = true;
	window.seoUrl = "${tokens?.url || ""}";
	window.lang = "${lang || ""}";
  window.devId = "${devId || ''}";
  window.mcid = "${mcid || ''}";
	window.seoScreenParams = {trip : 'oneWay',
            		  classtype : 'E',
            		  fromcityname : '${tokens?.src_city_name || ""}',
            		  tocityname   : '${tokens?.dest_city_name || ""}',
            		  fromcity : '${tokens?.src_city_code || ""}',
            		  tocity   : '${tokens?.dest_city_code || ""}',
            		  childcount : 0,
            		  infantcount : 0,
            		  adultcount : 1,
            		  depdate : '${tokens?.cheap_MMddyyyy || ""}',
            		  isIntl : false,
            		  airlinecode : '${tokens?.airline_code || ""}'};
	window.urlParamsString = "?trip=oneWay&classtype=E&fromcity=${tokens?.src_city_code || ""}&tocity=${
            tokens?.dest_city_code || ""
          }&fromcityname=${tokens?.src_city_name || ""}&tocityname=${
            tokens?.dest_city_name || ""
          }&childcount=0&adultcount=1&infantcount=0&depdate=${
            tokens?.cheap_MMddyyyy || ""
          }&isIntl=false";`,
        }}
        type="application/javascript"
      />
      <style dangerouslySetInnerHTML={{ __html: seoBaseMin }} />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      <style dangerouslySetInnerHTML={{ __html: jqueryUIMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: commonHeaderCss }} />
      <style dangerouslySetInnerHTML={{ __html: bankOfferCSS }} />
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <style dangerouslySetInnerHTML={{ __html: baseMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: flightsInlineCSSMob }} />
      <link href={`${cssPath}/flightNewIndexLanding.min.css`} rel="stylesheet" />
      <style dangerouslySetInnerHTML={{ __html: seoFlightMobCss }} />
      <style dangerouslySetInnerHTML={{ __html: footerMobCss }} />
      <script type="text/javascript" src="https://code.jquery.com/jquery-3.5.1.min.js" />
      <script src="https://code.jquery.com/ui/1.13.2/jquery-ui.min.js" />
      <script type="text/javascript" src={`${jsPath}/jquery-ui-flights.min.js`} />
      <style
        dangerouslySetInnerHTML={{
          __html:
            '@media screen and (max-width:768px){.modify-search-header-components.inOverlay{margin-top:0}.modify-search-header{padding:0;z-index:2}.seo-header h1{padding-bottom:20px;margin-bottom:0}.seo-header{background:#0a223d}}@media screen and (max-width:768px){.fli-intl-container{padding-top:170px}.fli-intl-container{width:90%}}@media screen and (max-width:480px){body{overflow-x:hidden}}@media screen and (min-width:1200px){.makeCenterCol{max-width:1200px!important;padding-left:0!important;padding-right:0!important;margin:0 auto!important;float:none!important}}.seoContentMiddle.airline-dtls-view{margin-top:20px!important;padding:0!important}.breadcrumb{padding:8px 15px;margin:0!important;list-style:none;background-color:#fff;border-radius:10px;border:1px solid #d8eaff;display:flex}.breadcrumb>.active{color:#777}.breadcrumb>li,.pagination{display:flex}.breadcrumb a{color:#006dff;text-decoration:none;cursor:pointer}.breadcrumb>li+li:before{padding:5px 5px;color:#aaa;content:"/\u00a0";font-size:18px}#seoContentTop{background-image:linear-gradient(to right,#fff,#e8fde9);color:#000;align-items:center;padding:10px;border-radius:2px;box-shadow:0 2px 4px 0 rgb(0 0 0 / 15%);line-height:18px;margin:10px 0}img{position:relative}img[alt]:after{display:block;position:absolute;top:0;left:0;width:100%;height:100%;background-color:#fff;font-weight:var(--font-bolder, 900);line-height:1;text-align:center;content:attr(alt)}.appendBottom16{margin-bottom:16px}',
        }}
      />
    </>
  );
};
